import { createContext } from 'react';
import { AccountAndBillingHostProps } from './types';

export const AccountAndBillingContext = createContext<AccountAndBillingHostProps | null>(null);
